import type { ForwardRefExoticComponent, RefAttributes } from 'react';
import { forwardRef } from 'react';

import { useContinuousScoring } from '../../hooks/useContinuousScoring';
import type { WidgetRef } from '../../types';
import { ContinuousScoringNotice } from './ContinuousScoringNotice';

type WidgetContent = ForwardRefExoticComponent<RefAttributes<WidgetRef>>;

/**
 * Render-time half of the `requiresRoundedScores` gate; the picker half is in
 * `getPaletteItems`. A placed widget stays on the dashboard and explains
 * itself, and plots again once the organisation rounds scores again.
 */
export const withRoundedScoresRequired = (
  Content: WidgetContent
): WidgetContent => {
  const Gated = forwardRef<WidgetRef>((_props, ref) => {
    const isContinuousScoring = useContinuousScoring();

    return isContinuousScoring ? (
      <ContinuousScoringNotice widget={'heatmap'} />
    ) : (
      <Content ref={ref} />
    );
  });
  Gated.displayName = `withRoundedScoresRequired(${Content.displayName ?? 'Widget'})`;

  return Gated;
};
